import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!) {
    deleteEtlQuery (input: { id: $id }) {
        __typename
        ${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/DeleteMutation.js